<template>
  <div
    class="app-main"
    :class="{ 'app-main-student': $route.name === 'Student' }"
    :style="{ '--color-filter': `hue-rotate(${colorFilterDelta}deg)` }"
  >
    <img
      ref="bgImg"
      crossOrigin="anonymous"
      :src="background1"
      style="display: none;"
    />
    <el-scrollbar
      view-class="sv"
      wrap-class="app-main-wrapper"
      :style="`filter:${colorFilter}`"
    >
      <NavMenu
        :logo="systemSetting.topIcon"
        :system-name="systemSetting.topName"
        :fixed="backgroundAuto"
        :changeNavStatus="changeNavStatus"
        @showQrList="dialogQrCodeVisible = true"
      />
      <section class="section">
        <transition name="fade-in-side" mode="out-in">
          <keep-alive include="BusinessManagement">
            <router-view />
          </keep-alive>
        </transition>
      </section>
      <FooterNav
        :tele-phone="systemSetting.telePhone"
        :address="systemSetting.address"
        :quick-link="systemSetting.quickEntry"
        :links="systemSetting.friendLink"
        :copyright="systemSetting.copyRight"
        :motto="systemSetting.motto"
        :footer-logo="systemSetting.footerIcon"
      />
    </el-scrollbar>
    <el-backtop target=".app-main-wrapper"></el-backtop>
    <div
      v-if="schoolCode === 'jiangxishifan'"
      class="themeBg"
      :style="{
        '--color-filter': `hue-rotate(${colorFilterDelta}deg)`,
        'background-size': 'cover',
        'background-image': `${mask},url(${background})`,
      }"
    >
      <div
        class="themeBgCover jxsfThemeBgCover"
        :style="{ filter: `blur(${filterBg}px)` }"
      ></div>
    </div>
    <div
      v-else
      class="themeBg"
      :style="{
        '--color-filter': `hue-rotate(${colorFilterDelta}deg)`,
        'background-size': 'cover',
        'background-image': `${mask},url(${background})`,
      }"
    >
      <div
        class="themeBgCover"
        :class="{ themeBgOther: filterBg !== 0 }"
        :style="{ filter: `blur(${filterBg}px)` }"
      ></div>
    </div>
    <el-dialog
      title="常用二维码"
      :visible.sync="dialogQrCodeVisible"
      width="auto"
    >
      <ul class="nav-download-apps-list">
        <li
          v-for="(qrCode, qrCodeIndex) in (systemSetting.qrCodeList || [])"
          :key="qrCodeIndex"
        >
          <img :src="qrCode.qrUrl" />
          <span>{{ qrCode.name }}</span>
        </li>
      </ul>
    </el-dialog>
  </div>
</template>
<script>
  import { mapGetters, mapMutations } from 'vuex'
  import decodeTicket from '@/utils/decodeTicket'
  import { getSetting } from '@/api/system-setting'
  import NavMenu from '@/layout/NavMenu'
  import configR from '@/configs.js'
  export default {
    name: 'AppMain',
    components: {
      NavMenu,
    },
    provide() {
      return {
        reload: this.reload,
      }
    },
    data() {
      return {
        scrollWrapper: null,
        backgroundAuto: true,
        scrollTop: '',
        schoolCode: configR.envConfigs.SCHOOL_CODE,
        dialogQrCodeVisible: false,
      }
    },
    computed: {
      ...mapGetters(['userInfo', 'userIdentity', 'systemSetting', 'themeConfig']),
      colorFilterDelta() {
        return -this.themeConfig.currentSkinItem.colorFilterDelta
      },
      key() {
        return this.$route.fullPath
      },
      //是否登录
      hasUserInfo() {
        return Object.keys(this.userInfo).length > 1
      },
      colorFilter() {
        return `hue-rotate(${this.themeConfig.currentSkinItem.colorFilterDelta}deg)`
      },
      mask() {
        // if (["Tourist", "Visitor", "Teacher", "Admin", "Student"].includes(this.$route.name)) {
        //   return 'linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0))';
        // }else if(["ServiceCenter"].includes(this.$route.name)){
        //   return 'linear-gradient(to bottom, rgba(255,255,255,0.2), rgba(255,255,255,0.2))';
        // }else {
        //   return 'linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.3))';
        // }
        return 'linear-gradient(to bottom, rgba(255,255,255,0.2), rgba(255,255,255,0.2))'
      },
      changeNavStatus() {
        // return (["Student"].includes(this.$route.name) || this.scrollTop >= 40);
        return this.scrollTop >= 60
      },
      filterBg() {
        if (
          ['Tourist', 'Visitor', 'Teacher', 'Admin'].includes(this.$route.name)
        ) {
          return 0
        } else if (['Student'].includes(this.$route.name)) {
          return 0
        } else {
          if (this.schoolCode === 'pingdingshan') {
            return 40
          } else {
            return 0
          }
        }
      },
      background() {
        return this.themeConfig.currentSkinItem.preview
      },
      background1() {
        return require('@/assets/Background/home.jpg')
      },
    },
    watch: {
      systemSetting: {
        handler: 'updateSystemSetting',
      },
    },
    async created() {
      let { code, data } = await getSetting()
      if (code == 0 && data) {
        this.$store.commit('SET_SYSTEM_SETTING', data)
      }
    },
    mounted() {
      this.watchScrollEvent()
    },
    beforeDestroy() {
      this.removeScrollEvent()
    },
    methods: {
      ...mapMutations(['SET_USER_THEME_CONFIG']),

      updateSystemSetting() {
        let favIcon = this.systemSetting.favIcon
        let title = this.systemSetting.title
        if (title) {
          document.title = title
        }
        if (favIcon) {
          let link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement('link')
          link.type = 'image/x-icon'
          link.rel = 'shortcut icon'
          link.href = favIcon
          if (document.getElementsByTagName('head')[0]) {
            document.getElementsByTagName('head')[0].appendChild(link)
          }
        }
      },
      // 获取用户登录状态
      handleGetCodeAndState() {
        if (!this.hasUserInfo && window.location.href.indexOf('ticket=')) {
          let userInfo = decodeTicket()
          if (userInfo) {
            this.$store.commit('SET_TOKEN', userInfo.idToken)
            this.$store.commit('SET_USER_INFO', userInfo)
            this.$store.commit('SET_USER_IDENTITY', 'Student')
          }
        }
      },
      // 监听滚动事件
      watchScrollEvent() {
        this.scrollWrapper = document.querySelector('.app-main-wrapper')
        this.scrollWrapper.addEventListener('scroll', this.scrollEvent)
      },
      // 移除滚动事件
      removeScrollEvent() {
        this.scrollWrapper.removeEventListener('scroll', this.scrollEvent)
        this.scrollWrapper = null
      },
      // 滚动事件
      scrollEvent(event) {
        // 滚动条滚动时距离顶部的距离
        let scrollTop = event.target.scrollTop
        this.scrollTop = scrollTop
        this.$store.commit('setScrollTop', scrollTop)

        // 以下代码，有用，别注释
        // 可视区域的高度
        let windowHeight =
          document.documentElement.clientHeight || document.body.clientHeight
        // 滚动条的总高度
        let scrollHeight = event.target.scrollHeight
        // 滚动至底部的条件
        if (Math.ceil(scrollTop + windowHeight + 60) >= scrollHeight) {
          this.$store.commit('scrollToBottom')
        }
      },
    },
  }
</script>
<style lang="scss">
  @import '@/styles/variables.scss';
  .keep-hue {
    filter: var(--color-filter, hue-rotate(0deg));
  }
  .filterZero {
    filter: hue-rotate(0deg);
  }
  .app-main {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: cover;
    box-sizing: border-box;

    &-wrapper {
      margin-bottom: 0 !important;
      //overflow-x: hidden !important;
      transition: $transition-primary !important;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      min-height: 100%;
      z-index: 199;
    }

    .section {
      position: relative;
      width: 100%;
      padding-top: 110px;
      min-height: calc(100vh - 110px);

      &-content {
        position: relative;
        display: flex;
        justify-content: space-between;
        padding-top: 20px;
        padding-bottom: 30px;
        box-sizing: border-box;
      }

      > .section-content {
        min-height: calc(100vh - 160px);
      }
    }
  }
  .themeBg {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
  }
  .themeBgCover {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0;
    z-index: 0;
    background: inherit;
    &.themeBgOther {
      width: 120%;
      height: 120%;
      left: -150px;
    }
    &.jxsfThemeBgCover {
      width: 100%;
      height: 100%;
      left: 0;
    }
  }
  .nav-download-apps-list {
    display: flex;
    justify-content: space-between;
    li {
      max-width: 100%;
      text-align: center;
      margin-right: 145px;
      display: flex;
      flex-direction: column;
      align-items: center;
      &:last-child {
        margin-right: 0px;
      }
      img {
        max-width: 100%;
        height: auto;
        margin-bottom: 20px;
      }
      span {
      }
    }
  }
</style>
